import { formatBodyWeight, formatResultWeight } from '~/utils/weight';
import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { useAuthentication } from '~/hooks/useAuthentication';
import { RecordTableWrapper } from './record-table-wrapper';
import { Heading } from '~/components/Heading/Heading';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';
import { RecordDiscipline } from '~/apis/ssf';
import { Link } from '~/components/Link/Link';
import { querySchema } from './query-schema';
import { formatDate } from '~/utils/date';

interface Props {
  discipline: RecordDiscipline;
}

export function RecordTable({ discipline }: Props) {
  const { user, isSuperUser } = useAuthentication();
  const { values } = useFilterForm(querySchema.parse);

  const canManageRecords = isSuperUser || values.district_id === user?.permissions.districts_admin[0].id;

  return (
    <div>
      <Heading as="h3">{discipline.label}</Heading>

      <RecordTableWrapper>
        {discipline.records.map((record, index) => (
          <Table.Row key={`record-${index}`}>
            <Table.Col>{record.weight_class.name}</Table.Col>
            <Table.Col>
              {record.person ? (
                <Link to={`/lifters/${record.person?.id}`}>
                  {record.person.first_name} {record.person.last_name}
                </Link>
              ) : (
                'Standardrekord'
              )}
            </Table.Col>
            <Table.Col>{record.club && <Link to={`/clubs/${record.club.id}`}>{record.club.name}</Link>}</Table.Col>
            <Table.Col>{record.body_weight ? formatBodyWeight(record.body_weight) : '-'}</Table.Col>
            <Table.Col>{formatResultWeight(record.result)}</Table.Col>
            <Table.Col>{record.date ? formatDate(new Date(record.date), 'yyyy-mm-dd') : '-'}</Table.Col>
            {canManageRecords && (
              <Table.Col align="right">
                <Table.Context
                  items={[
                    <ContextMenu.Item label="Hantera rekordresultat" key="edit" to={`/records/manage/${record.id}`} />,
                  ]}
                />
              </Table.Col>
            )}
          </Table.Row>
        ))}
      </RecordTableWrapper>
    </div>
  );
}
